import React from 'react'
import { any, async, fromJSX, getValue, Updater, Widget } from 'widgets-for-react'
import { AnnouncementBar } from '../../../components/01-atoms/AnnouncementBar/AnnouncementBar.layout'
import { State } from '../../cmsPage.widget'
import { fieldUpdater } from '@shared/Frontend/utils/fieldUpdater'

export function announcementBarWidget(
  state: State['CMSHeaderState']['announcement'],
): Widget<Updater<State['CMSHeaderState']>> {
  const announcement = getValue(state)
  return any([
    async(state).map(fieldUpdater<State['CMSHeaderState']>()('announcement')),
    fromJSX(() =>
      announcement ? (
        <AnnouncementBar
          id={announcement.id}
          text={announcement.text}
          link={announcement.link}
          theme={announcement.theme}
        />
      ) : (
        <></>
      ),
    ),
  ])
}
